export const VIEWING_APPLICANTS_INFO_ITEM_ATTRIBUTE = 'data-applicant-id'

export const VIEWING_APPLICANTS_INFO_VISIBLE_COUNT = 1
